<template>
    <div class="relative bg-white">
        <div class="lg:absolute lg:inset-0 lg:left-1/2">
            <img
                class="h-64 w-full bg-gray-50 object-cover sm:h-80 lg:absolute lg:h-full"
                src="https://images.unsplash.com/photo-1629802478555-9dab63da9925?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt=""
            />
        </div>
        <div
            class="pb-24 pt-16 sm:pb-32 sm:pt-24 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:pt-32"
        >
            <div class="px-6 lg:px-8">
                <div class="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
                    <h2
                        class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
                    >
                        Learn more
                    </h2>
                    <p class="mt-6 text-lg leading-8 text-gray-600">
                        Tell us what you are interested in and we will get back
                        to you with more information.
                    </p>
                    <div
                        v-if="submitted"
                        class="mt-16 rounded-md bg-green-50 p-8 text-center"
                    >
                        <h3 class="text-lg font-semibold text-green-800">Message sent!</h3>
                        <p class="mt-2 text-sm text-green-700">
                            Thank you for reaching out. We'll be in touch soon.
                        </p>
                    </div>

                    <form
                        v-else
                        ref="contactForm"
                        action="api/contact"
                        method="POST"
                        class="mt-16"
                        @submit.prevent="handleSubmit"
                    >
                        <div
                            class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2"
                        >
                            <div>
                                <label
                                    for="first-name"
                                    class="block text-sm font-semibold leading-6 text-gray-900"
                                    >First name</label
                                >
                                <div class="mt-2.5">
                                    <input
                                        id="first_name"
                                        v-model="form.first_name"
                                        type="text"
                                        name="first_name"
                                        autocomplete="given-name"
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-600 sm:text-sm sm:leading-6"
                                    />
                                    <p v-if="form.errors.first_name" class="mt-1 text-sm text-red-600">{{ form.errors.first_name }}</p>
                                </div>
                            </div>
                            <div>
                                <label
                                    for="last-name"
                                    class="block text-sm font-semibold leading-6 text-gray-900"
                                    >Last name</label
                                >
                                <div class="mt-2.5">
                                    <input
                                        id="last_name"
                                        v-model="form.last_name"
                                        type="text"
                                        name="last_name"
                                        autocomplete="family-name"
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-600 sm:text-sm sm:leading-6"
                                    />
                                    <p v-if="form.errors.last_name" class="mt-1 text-sm text-red-600">{{ form.errors.last_name }}</p>
                                </div>
                            </div>
                            <div class="sm:col-span-2">
                                <label
                                    for="email"
                                    class="block text-sm font-semibold leading-6 text-gray-900"
                                    >Email</label
                                >
                                <div class="mt-2.5">
                                    <input
                                        id="email"
                                        v-model="form.email"
                                        name="email"
                                        type="email"
                                        autocomplete="email"
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-600 sm:text-sm sm:leading-6"
                                    />
                                    <p v-if="form.errors.email" class="mt-1 text-sm text-red-600">{{ form.errors.email }}</p>
                                </div>
                            </div>
                            <div class="sm:col-span-2">
                                <label
                                    for="company"
                                    class="block text-sm font-semibold leading-6 text-gray-900"
                                    >Company</label
                                >
                                <div class="mt-2.5">
                                    <input
                                        id="company"
                                        v-model="form.company"
                                        type="text"
                                        name="company"
                                        autocomplete="organization"
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-600 sm:text-sm sm:leading-6"
                                    />
                                </div>
                            </div>
                            <div class="sm:col-span-2">
                                <div
                                    class="flex justify-between text-sm leading-6"
                                >
                                    <label
                                        for="phone"
                                        class="block font-semibold text-gray-900"
                                        >Phone</label
                                    >
                                    <p
                                        id="phone-description"
                                        class="text-gray-400"
                                    >
                                        Optional
                                    </p>
                                </div>
                                <div class="mt-2.5">
                                    <input
                                        id="phone"
                                        v-model="form.phone"
                                        type="tel"
                                        name="phone"
                                        autocomplete="tel"
                                        aria-describedby="phone-description"
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-600 sm:text-sm sm:leading-6"
                                    />
                                </div>
                            </div>
                            <div class="sm:col-span-2">
                                <div
                                    class="flex justify-between text-sm leading-6"
                                >
                                    <label
                                        for="message"
                                        class="block text-sm font-semibold leading-6 text-gray-900"
                                        >How can we help you?</label
                                    >
                                    <p
                                        id="message-description"
                                        class="text-gray-400"
                                    >
                                        Max 500 characters
                                    </p>
                                </div>
                                <div class="mt-2.5">
                                    <textarea
                                        id="message"
                                        v-model="form.message"
                                        name="message"
                                        rows="4"
                                        aria-describedby="message-description"
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-600 sm:text-sm sm:leading-6"
                                    />
                                </div>
                            </div>
                            <fieldset>
                                <legend
                                    class="block text-sm font-semibold leading-6 text-gray-900"
                                >
                                    Interested in learning more about:
                                </legend>
                                <legend class="sr-only">Notifications</legend>
                                <div class="space-y-5 pt-4">
                                    <div class="relative flex items-start">
                                        <div class="flex h-6 items-center">
                                            <input
                                                id="in_house"
                                                v-model="
                                                    form.selections.in_house
                                                "
                                                aria-describedby="in-house-instruction"
                                                name="comments"
                                                type="checkbox"
                                                class="h-4 w-4 rounded border-gray-300 text-red-600 focus:ring-red-600"
                                            />
                                        </div>
                                        <div class="ml-3 text-sm leading-6">
                                            <label
                                                for="in_house"
                                                class="font-medium text-gray-900"
                                                >In-House Instruction</label
                                            >
                                        </div>
                                    </div>
                                    <div class="relative flex items-start">
                                        <div class="flex h-6 items-center">
                                            <input
                                                id="virtual"
                                                v-model="
                                                    form.selections.virtual
                                                "
                                                aria-describedby="virtual-instruction"
                                                name="candidates"
                                                type="checkbox"
                                                class="h-4 w-4 rounded border-gray-300 text-red-600 focus:ring-red-600"
                                            />
                                        </div>
                                        <div class="ml-3 text-sm leading-6">
                                            <label
                                                for="virtual"
                                                class="font-medium text-gray-900"
                                                >Virtual Instruction</label
                                            >
                                        </div>
                                    </div>
                                    <div class="relative flex items-start">
                                        <div class="flex h-6 items-center">
                                            <input
                                                id="adult_ed"
                                                v-model="
                                                    form.selections.adult_ed
                                                "
                                                aria-describedby="adult-education"
                                                name="offers"
                                                type="checkbox"
                                                class="h-4 w-4 rounded border-gray-300 text-red-600 focus:ring-red-600"
                                            />
                                        </div>
                                        <div class="ml-3 text-sm leading-6">
                                            <label
                                                for="adult_ed"
                                                class="font-medium text-gray-900"
                                                >Adult Education</label
                                            >
                                        </div>
                                    </div>
                                    <div class="relative flex items-start">
                                        <div class="flex h-6 items-center">
                                            <input
                                                id="clinician"
                                                v-model="form.selections.clinician"
                                                aria-describedby="clinician-services"
                                                name="offers"
                                                type="checkbox"
                                                class="h-4 w-4 rounded border-gray-300 text-red-600 focus:ring-red-600"
                                            />
                                        </div>
                                        <div class="ml-3 text-sm leading-6">
                                            <label
                                                for="clinician"
                                                class="font-medium text-gray-900"
                                                >Clinician Services</label
                                            >
                                        </div>
                                    </div>
                                    <div class="relative flex items-start">
                                        <div class="flex h-6 items-center">
                                            <input
                                                id="repair"
                                                v-model="
                                                    form.selections.repair
                                                "
                                                aria-describedby="repair-services"
                                                name="offers"
                                                type="checkbox"
                                                class="h-4 w-4 rounded border-gray-300 text-red-600 focus:ring-red-600"
                                            />
                                        </div>
                                        <div class="ml-3 text-sm leading-6">
                                            <label
                                                for="repair"
                                                class="font-medium text-gray-900"
                                                >Repair Services</label
                                            >
                                        </div>
                                    </div>
                                    <div class="relative flex items-start">
                                        <div class="flex h-6 items-center">
                                            <input
                                                id="affiliate"
                                                v-model="form.selections.affiliate"
                                                aria-describedby="affiliate-repair-shop"
                                                name="offers"
                                                type="checkbox"
                                                class="h-4 w-4 rounded border-gray-300 text-red-600 focus:ring-red-600"
                                            />
                                        </div>
                                        <div class="ml-3 text-sm leading-6">
                                            <label
                                                for="affiliate"
                                                class="font-medium text-gray-900"
                                                >Becoming an Affiliate Repair
                                                Shop</label
                                            >
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div
                            class="mt-10 flex justify-end border-t border-gray-900/10 pt-8"
                        >
                            <button
                                type="submit"
                                :disabled="form.processing"
                                class="rounded-md bg-red-700 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {{ form.processing ? 'Sending…' : 'Send message' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import GuestLayout from "@/Layouts/GuestLayout.vue";
import { ref } from "vue";
import { useForm } from "@inertiajs/vue3";

defineOptions({ layout: GuestLayout });

const submitted = ref(false);

const form = useForm({
    first_name: null,
    last_name: null,
    email: null,
    company: null,
    phone: null,
    message: null,
    selections: {
        in_house: false,
        virtual: false,
        adult_ed: false,
        clinician: false,
        repair: false,
        affiliate: false,
    },
});

function handleSubmit() {
    form.post("/api/contact", {
        onSuccess: () => {
            submitted.value = true;
            form.reset();
        },
    });
}
</script>
